import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { noteActions } from '_actions';
import { DBCheckBoxObjective, DBTextAreaObjective, ObjectiveFlag, DBDropDownObjective, DBTextField } from '_components';
import styles from './Common.module.css'

class SpecialTestPelvicFloorAssessmentOrganProlapse extends React.Component {

    handleNoneClick(selected) {
        if (selected) {
            let fields = [
                'TSPELPROANTWALL',
                'TSPELPROPOSTWALL',
                'TSPELPROURETHROCELE',
                'TSPELPROUTERINE'
            ];
            this.props.clearFields(this.props.noteId, 'PTOBJECTIVESPECTESTS', 'TSNO', this.props.tsno, fields);
        }
    }

    render() {
        return (
            <div>     
                <div className={styles.checkbox_row}>
                    <ObjectiveFlag className={styles.flag} flagged={this.props.flagged} mopno={this.props.mopno} flagText='Special Test - Pelvic Floor Assessment - Organ Prolapse'/>
                    <span className={styles.spacer} />
                    <label className={styles.label}>Organ Prolapse</label>
                    <span className={styles.checkboxRow}>
                        <DBCheckBoxObjective noteId={this.props.noteId} entity='PTOBJECTIVESPECTESTS' entityKeyColumn='TSNO' entityKeyValue={this.props.tsno} field='TSPELPRONONE' label='None' className={styles.checkbox}
                            onClick={(selected) => this.handleNoneClick(selected)}
                        />
                    </span>
                </div>
                {this.props.noneSelected === false &&
                    <div>
                        
                        <div className={styles.checkbox_row}>
                            <span className={styles.flag} />
                            <span className={styles.spacer} />
                            <span className={styles.label} />
                            <span className={styles.checkboxRow}>
                                <DBCheckBoxObjective noteId={this.props.noteId} entity='PTOBJECTIVESPECTESTS' entityKeyColumn='TSNO' entityKeyValue={this.props.tsno} field='TSPELPROANTWALL' label='Anterior Wall' className={styles.checkbox} />
                            </span>
                        </div>
                        <div className={styles.checkbox_row}>
                            <span className={styles.flag} />
                            <span className={styles.spacer} />
                            <span className={styles.label} />
                            <span className={styles.checkboxRow}>
                                <DBCheckBoxObjective noteId={this.props.noteId} entity='PTOBJECTIVESPECTESTS' entityKeyColumn='TSNO' entityKeyValue={this.props.tsno} field='TSPELPROPOSTWALL' label='Posterior Wall' className={styles.checkbox} />
                            </span>
                        </div>
                        <div className={styles.checkbox_row}>
                            <span className={styles.flag} />
                            <span className={styles.spacer} />
                            <span className={styles.label} />
                            <span className={styles.checkboxRow}>
                                <DBCheckBoxObjective noteId={this.props.noteId} entity='PTOBJECTIVESPECTESTS' entityKeyColumn='TSNO' entityKeyValue={this.props.tsno} field='TSPELPROURETHROCELE' label='Urethrocele' className={styles.checkbox} />
                            </span>
                        </div>
                        <div className={styles.checkbox_row}>
                            <span className={styles.flag} />
                            <span className={styles.spacer} />
                            <span className={styles.label} />
                            <span className={styles.checkboxRow}>
                                <DBCheckBoxObjective noteId={this.props.noteId} entity='PTOBJECTIVESPECTESTS' entityKeyColumn='TSNO' entityKeyValue={this.props.tsno} field='TSPELPROUTERINE' label='Uterine' className={styles.checkbox} />
                            </span>
                        </div>
                    </div>
                }
                <div className={styles.textarea_row}>
                    <span className={styles.flag} />
                    <span className={styles.spacer} />
                    <label className={styles.textarea_label} >Organ Prolapse Comments</label>
                    <DBTextAreaObjective noteId={this.props.noteId} entity='PTOBJECTIVESPECTESTS' entityKeyColumn='TSNO' entityKeyValue={this.props.tsno} field='TSPELPROCOMMENTS' className={styles.comment} />
                </div>


                <div className={styles.checkbox_row}>
                    <ObjectiveFlag className={styles.flag} flagged={this.props.restToneFlagged} flagText='Special Test - Pelvic Resting Tone'/>
                    <span className={styles.spacer} />
                    <label className={styles.label}>Pelvic Resting Tone</label>
                    <span className={styles.oneLine}>
                    <DBDropDownObjective 
                        noteId={this.props.noteId} 
                        entity='PTOBJECTIVESPECTESTS' 
                        entityKeyColumn='TSNO' 
                        entityKeyValue={this.props.tsno} 
                        field='TSPELRESTTONE' 
                        className={styles.dropdown} 
                        customOptions={[
                            { id: 'Normal', value: 'Normal' },
                            { id: 'Increased tone (or hypertonic)', value: 'Increased tone (or hypertonic)' },
                            { id: 'Decreased tone', value: 'Decreased tone' },
                            { id: 'Other', value: 'Other' }
                        ]} 
                    />
                    {this.props.isOtherSelected && <DBTextField
                        noteId={this.props.noteId}
                        entity='PTOBJECTIVESPECTESTS' 
                        entityKeyColumn='TSNO' 
                        entityKeyValue={this.props.tsno} 
                        field='TSPELRESTTONEOTHER' 
                        className={styles.txtField} 
                    />}
                    
                    </span>
                </div>

                <div className={styles.checkbox_row}>
                    <ObjectiveFlag className={styles.flag} flagged={this.props.contractionFlagged} flagText='Special Test - Contraction Observation'/>
                    <span className={styles.spacer} />
                    <label className={styles.label}>Contraction Observation</label>
                    <span className={styles.oneLine}>

                    <div className={styles.checkbox_row}>
                       <span className={styles.checkboxRow}>
                           <DBCheckBoxObjective noteId={this.props.noteId} 
                           entity='PTOBJECTIVESPECTESTS' 
                           entityKeyColumn='TSNO' 
                           entityKeyValue={this.props.tsno} 
                           field='TSPELCONOBSANALWINK' 
                           label='Anal Wink' 
                           className={styles.checkbox} />
                       </span>
                    </div>

                    </span>
                </div>
                <div>
                        <div className={styles.checkbox_row}>
                            <span className={styles.flag} />
                            <span className={styles.spacer} />
                            <span className={styles.label} />
                            <span className={styles.checkboxRow}>
                                <DBCheckBoxObjective 
                                noteId={this.props.noteId} 
                                entity='PTOBJECTIVESPECTESTS' 
                                entityKeyColumn='TSNO' 
                                entityKeyValue={this.props.tsno} 
                                field='TSPELCONOBSPERINEALLIFT' 
                                label='Perineal Lift' 
                                className={styles.checkbox} />
                            </span>
                        </div>
                      
                        <div className={styles.checkbox_row}>
                            <span className={styles.flag} />
                            <span className={styles.spacer} />
                            <span className={styles.label} />
                            <span className={styles.checkboxRow}>
                                <DBCheckBoxObjective 
                                noteId={this.props.noteId} 
                                entity='PTOBJECTIVESPECTESTS' 
                                entityKeyColumn='TSNO' 
                                entityKeyValue={this.props.tsno} 
                                field='TSPELCONOBSNODLIFT' 
                                label='Clitoral Nod / Penile Lift' 
                                className={styles.checkbox_large_txt} />
                            </span>
                        </div>

                        <div className={styles.checkbox_row}>
                            <span className={styles.flag} />
                            <span className={styles.spacer} />
                            <span className={styles.label} />
                            <span className={styles.oneLine}>
                                <DBCheckBoxObjective 
                                noteId={this.props.noteId} 
                                entity='PTOBJECTIVESPECTESTS' 
                                entityKeyColumn='TSNO' 
                                entityKeyValue={this.props.tsno} 
                                field='TSPELCONOBSOTHER' 
                                label='Other' 
                                className={styles.checkbox} />
                           
                            {this.props.isContractionOtherSelected && 
                            <DBTextField
                                noteId={this.props.noteId}
                                entity='PTOBJECTIVESPECTESTS' 
                                entityKeyColumn='TSNO' 
                                entityKeyValue={this.props.tsno} 
                                field='TSPELCONOBSOTHERTXT' 
                                className={styles.other_txtField} 
                            />
                            } 
                            </span>
                        </div>

                      
                </div>
            </div>
        );
    }
}

function mapDispatchToProps(dispatch) {
    return {
        clearFields: bindActionCreators(noteActions.clearFields, dispatch)
    };
}

function mapStateToProps(state) {
    let noteId = state.ui.patientTabs[state.ui.patientCenter[state.ui.patients.selectedPtno].selectedTab].noteId;
    let noteType = parseInt(noteId.split("_")[0]);
    let pk = parseInt(noteId.split("_")[1]);
    let tsno = parseInt(Object.keys(state.entities.notes.PTOBJECTIVESPECTESTS)
        .find(key => (state.entities.notes.PTOBJECTIVESPECTESTS[key].TSEVNO === pk && noteType === 1)
            || (state.entities.notes.PTOBJECTIVESPECTESTS[key].TSNTNO === pk && noteType !== 1)));

    let flagged = false;
    if (
        state.entities.notes.PTOBJECTIVESPECTESTS[tsno].TSPELPROANTWALL ||
        state.entities.notes.PTOBJECTIVESPECTESTS[tsno].TSPELPROPOSTWALL ||
        state.entities.notes.PTOBJECTIVESPECTESTS[tsno].TSPELPROURETHROCELE ||
        state.entities.notes.PTOBJECTIVESPECTESTS[tsno].TSPELPROUTERINE) {
        flagged = true;
    }

    let restToneFlagged = state.entities.notes.PTOBJECTIVESPECTESTS[tsno]?.TSPELRESTTONE !== null && state.entities.notes.PTOBJECTIVESPECTESTS[tsno]?.TSPELRESTTONE !== undefined;
    let isOtherSelected = state.entities.notes.PTOBJECTIVESPECTESTS[tsno]?.TSPELRESTTONE !== null && state.entities.notes.PTOBJECTIVESPECTESTS[tsno]?.TSPELRESTTONE !== undefined && state.entities.notes.PTOBJECTIVESPECTESTS[tsno]?.TSPELRESTTONE === 'Other';
    
    let contractionFlagged = false;
    if (state.entities.notes.PTOBJECTIVESPECTESTS[tsno].TSPELCONOBSANALWINK ||
        state.entities.notes.PTOBJECTIVESPECTESTS[tsno].TSPELCONOBSPERINEALLIFT ||
        state.entities.notes.PTOBJECTIVESPECTESTS[tsno].TSPELCONOBSNODLIFT ||
        state.entities.notes.PTOBJECTIVESPECTESTS[tsno].TSPELCONOBSOTHER) {
            contractionFlagged = true;
    }

    let isContractionOtherSelected = state.entities.notes.PTOBJECTIVESPECTESTS[tsno]?.TSPELCONOBSOTHER !== null && state.entities.notes.PTOBJECTIVESPECTESTS[tsno]?.TSPELCONOBSOTHER !== undefined;
    
    return {
        noteId: noteId,
        tsno: tsno,
        flagged: flagged,
        restToneFlagged,
        isOtherSelected,
        contractionFlagged,
        isContractionOtherSelected,
        noneSelected: state.entities.notes.PTOBJECTIVESPECTESTS[tsno].TSPELPRONONE ? state.entities.notes.PTOBJECTIVESPECTESTS[tsno].TSPELPRONONE : false
    };
}

const connectedSpecialTestPelvicFloorAssessmentOrganProlapse = connect(mapStateToProps, mapDispatchToProps)(SpecialTestPelvicFloorAssessmentOrganProlapse);
export { connectedSpecialTestPelvicFloorAssessmentOrganProlapse as SpecialTestPelvicFloorAssessmentOrganProlapse };



